import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface WhatsNewState {
  isOpen: boolean
  readVersion: string
  showWhatsNew: boolean
  hasRead: () => boolean
  open: () => void
  close: () => void
  toggle: () => void
  setRead: (version: string) => void
}

export const useWhatsNewStore = create<WhatsNewState>()(
  devtools(
    persist(
      (set, get) => ({
        isOpen: false,
        readVersion: '1.0.0',
        showWhatsNew: true,
        hasRead: () => __APP_VERSION__ === get().readVersion,
        open: () => set({ isOpen: true, readVersion: __APP_VERSION__ }),
        close: () => set({ isOpen: false }),
        toggle: () => set((state) => ({ isOpen: !state.isOpen, readVersion: __APP_VERSION__ })),
        setRead: (version: string) => set({ readVersion: version }),
      }),
      {
        name: 'whats-new-storage',
        partialize: (state) => ({
          readVersion: state.readVersion,
          showWhatsNew: state.showWhatsNew,
        }),
      },
    ),
  ),
)
